import {ContentModule, ModuleProperties} from '@backstage-components/base';
import {css} from '@emotion/react';
import {AddToCalendarButton} from 'add-to-calendar-button-react';
import {FC} from 'react';
import {SchemaType} from './AddEventDefinition';
import {format} from 'date-fns';

export interface IAddEventProps extends ModuleProperties, SchemaType {}

export type AddEventComponentDefinition = ContentModule<
  'AddEvent',
  IAddEventProps & SchemaType
>;

export interface IContainerProps extends ModuleProperties, SchemaType {}

export const formatDate = (datetime: string): string =>
  format(new Date(datetime), 'yyyy-MM-dd');
export const formatTime = (datetime: string): string =>
  format(new Date(datetime), 'HH:mm');

export const AddEventComponent: FC<AddEventComponentDefinition> = (
  definition
) => {
  const {
    title,
    startTime,
    endTime,
    location,
    description,
    organizer,
    organizerEmail,
    timezone,
    buttonLabel,
    buttonColor,
    buttonStyle,
    listStyle,
    theme,
  } = definition.props;

  const styles = css`
    ${definition.style}
    ${definition.props.styleAttr}
  `;

  const colorStyle = buttonColor
    ? `--btn-background: ${buttonColor};`
    : undefined;
  const organizerDetail =
    organizer && organizerEmail ? `${organizer}|${organizerEmail}` : undefined;

  /**
   * See configuration options here: https://add-to-calendar-button.com/configuration
   */
  return (
    <div css={styles}>
      <AddToCalendarButton
        name={title}
        startDate={formatDate(startTime)}
        startTime={formatTime(startTime)}
        endDate={formatDate(endTime)}
        endTime={formatTime(endTime)}
        options={[
          'Apple',
          'Google',
          'iCal',
          'Microsoft365',
          'MicrosoftTeams',
          'Outlook.com',
          'Yahoo',
        ]}
        styleLight={colorStyle}
        styleDark={colorStyle}
        lightMode={theme}
        buttonStyle={buttonStyle}
        listStyle={listStyle}
        timeZone={timezone}
        location={location}
        description={description}
        organizer={organizerDetail}
        hideTextLabelButton={buttonLabel ? false : true}
        label={buttonLabel}
      ></AddToCalendarButton>
    </div>
  );
};
